import React, { useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../Images/Logo.png";
import "./Header.css";

function Header() {
  const [menuActive, setMenuActive] = useState(false);

  // Toggle menu visibility
  const toggleMenu = () => {
    setMenuActive(!menuActive);
  };

  return (
    <header>
      <div className="header-inner">
        {/* Logo */}
        <a href="/">
        <img src={logo} loading="lazy" alt="Logo" className="logo" />
        </a>
        {/* Hamburger Menu Icon */}
        <div className="hamburger" onClick={toggleMenu}>
          <div></div>
          <div></div>
          <div></div>
        </div>

        {/* Navigation Links */}
        <nav>
          <ul className={menuActive ? "active" : ""}>
            <li>
              <Link to="/" onClick={() => setMenuActive(false)}>
                <b>Home</b>
              </Link>
            </li>
            <li>
              <Link to="/batches" onClick={() => setMenuActive(false)}>
                <b>Batches</b>
              </Link>
            </li>
            <li>
              <Link to="/howitworks" onClick={() => setMenuActive(false)}>
                <b>How It Works</b>
              </Link>
            </li>
            
            <li>
              <Link to="/contact-us" onClick={() => setMenuActive(false)}>
                <b>Contact Us</b>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
}

export default Header;
